import React from "react";
import * as PropTypes from "prop-types";
import Jumbotron from "../components/Jumbotron";
import FeaturedQuarters from "../components/FeaturedQuarters";
import Link from "gatsby-link";
import styles from "../styles/single-story.module.scss";
import Img from "gatsby-image";
import PageWrapper from "../components/PageWrapper";
import SocialMedia from "../components/SocialMedia";
import Helmet from "react-helmet";
import { Player } from "video-react";
import "../../node_modules/video-react/dist/video-react.css";
import Download from "../components/icons/Download";

const propTypes = {
	data: PropTypes.object.isRequired
};

function createMarkup(value) {
	return {
		__html: value
	};
}

const SingleNews = ({ data, transition, location }) => {
	const story = data.pageSettings;

	return (
		<PageWrapper
			locale={story.node_locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main role="main" style={transition && transition.style}>
				<Helmet
					title={story.title + " | Mahidol Vivax Research Unit"}
					meta={[
						{ name: "description", content: "Sample" },
						{ name: "keywords", content: "malaria, vivax, mahidol, tropical medicine, lab, laboratory" },
						{
							name: "og:title",
							content:
								story.title + " | Mahidol Vivax Research Unit"
						},
						{
							name: "og:description",
							content: story.content.excerpt.excerpt
						},
						{
							name: "og:image",
							content: story.featuredImage.sizes.src
						}
					]}
				/>
				<Jumbotron
					type="jumbotron_b"
					bottomLine={true}
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
				>
					<Link
						to={
							story.cat === "latest"
								? "/" + story.node_locale + "/news"
								: "/" +
								  story.node_locale +
								  "/news/cat/" +
								  story.cat
						}
						className={styles.jumbotron_category}
					>
						{story.cat}
					</Link>
					<h1 className={styles.single_story_title}>{story.title}</h1>
					<ul className={styles.jumbotron_meta}>
						<li className="d-inline-block">
							<time>{story.datePublished}</time>
						</li>
						{/* <li className="d-inline-block">{story.author}</li> */}
					</ul>
				</Jumbotron>

				<div className={"container " + styles.article_container}>
					<div className={"row " + styles.article_content_news}>
						{story.featuredImage && (
							<div className={"col-12 " + styles.featured_image}>
								<Img
									title={story.featuredImage.title}
									alt={story.featuredImage.title}
									sizes={story.featuredImage.sizes}
								/>
							</div>
						)}

						<div
							className={"col-md-10 " + styles.news_article_main}
							dangerouslySetInnerHTML={createMarkup(
								story.content.content.html
							)}
						/>
						{story.videos &&
							story.videos.length > 0 &&
							story.videos.map(node => {
								return (
									<div
										className="col-md-10 mt-4"
										key={node.id}
									>
										<Player>
											<source src={node.file.url} />
										</Player>
									</div>
								);
							})}
						{story.otherAttachments &&
							story.otherAttachments.length > 0 && (
								<div className="col-md-10 mt-4" >
									<h4>Attachments:</h4>
									<ul className={"list-unstyled"}>
										{story.otherAttachments.map(node => {
											return (
												<li key={node.id} ><a href={node.file.url} target="_blank"><Download/>&nbsp;&nbsp; {node.title}</a></li>
											)
										})}
									</ul>
								</div>
							)}
						<div className="col-md-10 mt-5">
							<SocialMedia
								site={data.site.siteMetadata}
								pageTitle={story.title}
								location={location}
							/>
						</div>
					</div>
				</div>

				{/* <div className={"grey_bg"}>
					<FeaturedQuarters articles={story.related_articles}
						className={"container " + styles.related_stories}
					/>
				</div> */}
			</main>
		</PageWrapper>
	);
};

SingleNews.propTypes = propTypes;

export default SingleNews;

export const pageQuery = graphql`
	query newsQuery($id: String!) {
		site {
			siteMetadata {
				title
				siteUrl
			}
		}

		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulNews(id: { eq: $id }) {
			title
			datePublished(formatString: "Do MMMM, YYYY")
			slug
			featuredImage {
				title
				sizes(quality: 95) {
					base64
					aspectRatio
					src
					srcSet
					srcWebp
					srcSetWebp
					sizes
				}
			}
			videos {
				id
				file {
					url
					fileName
					contentType
				}

				title
				description
			}
			otherAttachments {
				id
				title
				file {
					url
					contentType
				}
			}

			cat

			content {
				content: childMarkdownRemark {
					html
				}
				excerpt: childMarkdownRemark {
					excerpt
				}
			}

			node_locale
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/news-template.js